import React, {FC} from "react";
import {SuggestedAvailability} from "../redux/types";
import {SetStepDataType} from "../types";
import {addDays, addMonths} from "date-fns";
import {Grid, LinearProgress, Typography} from "@material-ui/core";
import {SuggestedAvailabilityPreviewCard} from "./SuggestedAvailabilityPreviewCard";

interface MobileSuggestedAvailabilitiesProps {
    suggestedAvailabilities: SuggestedAvailability[];
    servicesIds: string[];
    onConfirm: (v: SetStepDataType) => void;
    fetchSuggestedAvailabilities: (from: number, to: number) => void;
    loading: boolean;
}


export const MobileSuggestedAvailabilities: FC<MobileSuggestedAvailabilitiesProps> = ({
                                                                                          suggestedAvailabilities,
                                                                                          servicesIds,
                                                                                          onConfirm,
                                                                                          fetchSuggestedAvailabilities,
                                                                                          loading
                                                                                      }) => {

    React.useEffect(() => {
        fetchSuggestedAvailabilities(
            addDays(new Date(), 2).getTime(),
            addMonths(new Date(), 3).getTime()
        );
    }, [fetchSuggestedAvailabilities]);

    return (
        <React.Fragment>
            {loading && <LinearProgress/>}
            {!loading && suggestedAvailabilities.length === 0 &&
            <Typography
                variant="h5"
                color="error"
                style={{textAlign: "center", marginTop: 16}}
            >
                Keine verfügbaren Termine
            </Typography>}
            <Grid container spacing={2}>
                {suggestedAvailabilities.map((s, i) => (
                    <SuggestedAvailabilityPreviewCard
                        key={"suggestedAvaialability-" + i}
                        servicesIds={servicesIds}
                        suggestedAvailability={s}
                        onConfirm={onConfirm}
                    />
                ))}
            </Grid>
        </React.Fragment>
    )
}
